module.exports = __webpack_public_path__ + "img/7z.6abb888b.svg";